import mutations from "./mutations"
import * as actions from "./actions";
import * as getters from "./getters";

let state = {
    curl: null
}

export default {mutations, actions, state, getters}



// WEBPACK FOOTER //
// ./src/store/modules/curl/index.js